module.exports = __webpack_public_path__ + "img/cofre.6ee6f4b7.png";